var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 7.33368L11.0713 11.071",
    stroke: "#057DCD",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14913 1.76956C2.09607 1.74719 2.03755 1.74116 1.98104 1.75222C1.92453 1.76328 1.8726 1.79093 1.83189 1.83165C1.79118 1.87236 1.76352 1.92429 1.75246 1.98079C1.7414 2.0373 1.74744 2.09582 1.7698 2.14888L5.55724 11.4712C5.58056 11.5276 5.62096 11.5753 5.67277 11.6076C5.72458 11.6398 5.7852 11.655 5.84609 11.651C5.90699 11.647 5.96511 11.6241 6.01227 11.5853C6.05944 11.5466 6.09328 11.4941 6.10904 11.4351L7.02327 7.89064C7.07193 7.6837 7.17626 7.49402 7.32498 7.34212C7.4737 7.19021 7.66114 7.08188 7.867 7.02885L11.4354 6.1088C11.4946 6.09342 11.5475 6.05976 11.5865 6.01262C11.6256 5.96547 11.6488 5.90722 11.6528 5.84614C11.6569 5.78507 11.6416 5.72426 11.6092 5.67236C11.5767 5.62046 11.5287 5.58009 11.4721 5.557L2.14913 1.76956Z",
    stroke: "#057DCD",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvRate);
export default __webpack_public_path__ + "static/media/Conv. Rate.8e01a1a32e42e2396cf1789a7814787d.svg";
export { ForwardRef as ReactComponent };